import { makeStyles } from 'tss-react/mui';

export const useOrderBookStyles = makeStyles()((theme) => ({
  horizontalPadding: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
  marginBottom: {
    paddingTop: theme.spacing(1.15),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
  item: {
    width: '100%',
  },
  subtitleBox: {
    paddingTop: theme.spacing(1.75),
    paddingBottom: theme.spacing(2),
  },
  activeOrderPadding: {
    paddingTop: theme.spacing(1.75),
  },
  modalContainer: {
    paddingTop: theme.spacing(2),
  },
  footerTitleContainer: {
    paddingBottom: theme.spacing(1),
  },
  footerContainer: {
    position: 'sticky',
    bottom: 0,
    paddingBottom: `${theme.spacing(2)} !important`,
    paddingTop: '0 !important',
    backgroundColor: theme.palette.background.paper,
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
  orderBookContainer: {
    paddingTop: theme.spacing(2),
    marginTop: 0,
    marginBottom: 0,
  },
  ordersOnBookContainer: {
    maxHeight: '85vh',
  },

  suggestionCheckboxContainer: {
    marginLeft: theme.spacing(0.4),
    paddingBottom: theme.spacing(1 / 2),
  },
}));
